import gql from 'graphql-tag';

export const USER_SETTINGS = gql`
  query userSettings($businessOwnerId: Int) {
    payPalSettings(businessOwnerId: $businessOwnerId) {
      id
      clientId
      clientSecret
    }
    stripeSettings(businessOwnerId: $businessOwnerId) {
      id
      publishableKey

    }
    payOnArrivalPossibility(businessOwnerId: $businessOwnerId) {
      id
      payOnArrival
    }
    googleAnalyticsSettings(businessOwnerId: $businessOwnerId) {
      id
      googleAnalyticsId
    }
    emailTemplates(businessOwnerId: $businessOwnerId) {
      subject
      body
    }
    trekksoftSettings(businessOwnerId: $businessOwnerId) {
      id
      apiClientId
      apiClientSecret
      merchantName
    }
    expediaSettings(businessOwnerId: $businessOwnerId) {
      id
      username
      password
    }
    trekksoftCategoriesMapping(businessOwnerId: $businessOwnerId) {
      id
      category
      categoryOnTrekksoft
    }
    bookingSettings(businessOwnerId: $businessOwnerId) {
      id
      username
      password
    }
  }
`;

export const USER_SETTINGS_WITHOUT_SECRET_KEYS = gql`
  query userSettings($businessOwnerId: Int) {
    payPalSettings(businessOwnerId: $businessOwnerId) {
      id
      clientId
      clientSecret
    }
    stripeSettings(businessOwnerId: $businessOwnerId) {
      id
      publishableKey
    }
    payOnArrivalPossibility(businessOwnerId: $businessOwnerId) {
      id
      payOnArrival
    }
    googleAnalyticsSettings(businessOwnerId: $businessOwnerId) {
      id
      googleAnalyticsId
    }
    emailTemplates(businessOwnerId: $businessOwnerId) {
      subject
      body
    }
    trekksoftSettings(businessOwnerId: $businessOwnerId) {
      id
      apiClientId
      apiClientSecret
      merchantName
    }
    expediaSettings(businessOwnerId: $businessOwnerId) {
      id
      username
    }
    trekksoftCategoriesMapping(businessOwnerId: $businessOwnerId) {
      id
      category
      categoryOnTrekksoft
    }
    bookingSettings(businessOwnerId: $businessOwnerId) {
      id
      username
    }
  }
`;
